interface AppConfig {
  apiUrl: string;
  region: string;
  tenantId: string;
  userPoolId: string;
  userPoolClientId: string;
  identityPoolId: string;
  cognitoDomain: string;
  appDomain: string;
}

let runtimeConfig: AppConfig | null = null;

export async function loadConfig(): Promise<void> {
  const res = await fetch('/config.json');
  runtimeConfig = await res.json();
}

export function getConfig(): AppConfig {
  if (!runtimeConfig) {
    throw new Error('Config not loaded. Call loadConfig() before using getConfig().');
  }
  return runtimeConfig;
}
